/** @format */

import React from "react";
import { Provider } from "react-redux";
import { render } from "react-snapshot";
import { App } from "./app/App";
import "./index.css";
import store from "./store";

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
